var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg033Protective = function Svg033Protective(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m365.545 112.248-7.09 29.15c48.733 12.384 105.794 22.869 119.478 48.354H34.067c13.847-25.788 72.363-36.382 119.478-48.354l-7.09-29.15C66.356 131.651 0 144.899 0 204.752v126.211l68.789 68.789H241v-75c0-8.276 6.724-15 15-15s15 6.724 15 15v75h172.211L512 330.963V204.752c0-60.502-68.254-73.56-146.455-92.504"
  })));
};
export default Svg033Protective;